
import React from 'react';
import Header from './Header';
import ImageSlider from './ImageSlider';
import Announcements from './Announcements';
import Details from './Details';
import ButtonGrid from './ButtonGrid';
import Footer from './Footer';
import PreFooter from './PreFooter';  
import Glimpse from './Glimpse';


const Home = () => {
  return (
    <div>
      <Header />
      <ImageSlider />
      <Details />
      <Glimpse />
      <ButtonGrid />
      <Announcements />
      <PreFooter />
      <Footer />
    </div>
  );
};

export default Home;
